import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'components/HeroSemantic';
import useTheme from 'hooks/useTheme';

const Logo = props => {
  const { tenant, inverted, src, darkSrc, style } = props;
  const theme = useTheme();
  // Each tenant ships an inverted ("/logo.png") asset designed for dark
  // backgrounds and a regular ("/splashscreen1x.png") asset for light ones.
  // Use the inverted asset in dark mode even if the caller didn't ask for it,
  // otherwise the logo blends into the dark page background. Callers that need
  // a custom dark asset (e.g. Skye's typographic SVG is too low-contrast on a
  // dark background) can pass `darkSrc` to override only in dark mode.
  const isDark = theme === 'dark';
  const useInverted = inverted || isDark;
  const defaultSrc = useInverted ? '/logo.png' : '/splashscreen1x.png';
  const imgSrc = (isDark && darkSrc) || src || defaultSrc;
  const alt = {
    kiniseko: 'Ki Niseko logo',
    nisekocentral: 'Niseko Central logo',
    skye: 'Skye Niseko logo',
  };

  // Return null if there is no tenant matched
  if (!Object.keys(alt).includes(tenant)) {
    return null;
  }

  // `objectFit: contain` preserves aspect ratio when callers pass both
  // maxWidth and maxHeight (e.g. mobile sidebar) — without it the Skye logo
  // stretches to fill the bounding box.
  return <Image src={imgSrc} alt={alt[tenant]} style={{ objectFit: 'contain', ...style }} />;
};

Logo.propTypes = {
  tenant: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  src: PropTypes.string,
  darkSrc: PropTypes.string,
  style: PropTypes.object,
};

export default Logo;
